<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-header">
        <div class="col-6" style="padding: 0; display: flex;">
          <div class="header-title">
            <p>
              <a [routerLink]="['/' + rfi.ContractId + '/list']">
                RFI list &gt;
              </a>
              <span> {{ rfi.Guid && rfi.Guid !== "" ? "Edit" : "New" }} RFI</span>
            </p>

            <h1>
              <i class="icon icon-lg icon-pencil"></i>

              <span
                >{{
                rfi.Guid && rfi.Guid !== ""
                ? IsRevise
                ? "Revise"
                : "Edit Draft"
                : "CREATE NEW"
                }}
                RFI</span
                >
              </h1>
            </div>
            @if (IsRevise) {
              <div style="flex: 1; display: flex; align-items: flex-end;">
                <div class="header-subTitle" style="margin-left: auto;">{{ rfi.RFINumber }}</div>
              </div>
            }
          </div>
          <div class="col-6" style="padding: 0;">
            <div class="header-actions">
              <aecom-button innerClass="btn lg outline orange" (click)="back()">
                back
              </aecom-button>

              @if (rfi.Guid) {
                <aecom-button
                  innerClass="btn lg outline orange"
                  (click)="baseFunctionService.dbVoidRFI()"
                  >
                  void
                </aecom-button>
              }

              <!-- <aecom-button
              *ngIf="rfi.guid"
              innerClass="btn lg outline orange"
              (click)="deletageRFI()"
              >
              delegate
            </aecom-button> -->

            <aecom-button
              [theme]="'light'"
              [disabled]="!hasChanges() ? true : null"
              innerClass="btn lg solid green"
              (click)="saveRFIDraft()"
              >
              save draft
            </aecom-button>

            <aecom-button
              [theme]="'light'"
              [disabled]="!canIssue() ? true : null"
              innerClass="btn lg solid blue"
              (click)="issueRFI()"
              >
              issue rfi
            </aecom-button>

          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <aecom-form columns="12">
        <div style="grid-column: span 6 / auto; position: relative">
          <aecom-form-group
            title="DETAIL"
            columnSpan="6"
            columns="6"
            style="display: block; margin-bottom: 10px; min-height: 60%"
            >
            @if (!IsGARContract) {
              <aecom-form-item
                columnSpan="3" [label]="'Internal Reference Number'">
                <aecom-textbox
                  [theme]="'light'"
                  [(ngValue)]="rfi.ContractorReference"
                  [validate]="baseFunctionService.isInputInvalid(rfi.ContractorReference)"
                ></aecom-textbox>
              </aecom-form-item>
            }

            <aecom-form-item
              columnSpan="6"
              [label]="'Title'"
              [property]="getStringLength(rfi.Title) + '/' + maxLength100 + ' characters'"
              [required]="true"
              >
              <aecom-textbox
                [theme]="'light'"
                [notEmpty]="true"
                [maxlength]="maxLength100"
                [(ngValue)]="rfi.Title"
                [validate]="
                  (attemptToIssue && getStringLength(rfi.Title)===0) || getStringLength(rfi.Title) > maxLength100 || baseFunctionService.isInputInvalid(rfi.Title)
                "
              ></aecom-textbox>
            </aecom-form-item>

            <aecom-form-item
              columnSpan="6"
              [label]="'Question'"
              [property]="getStringLength(rfi.Question) + '/' + maxLength1000 + ' characters'"
              [required]="true"
              >
              <aecom-textbox
                rows="5"
                [theme]="'light'"
                [notEmpty]="true"
                [maxlength]="maxLength1000"
                [isMultiLine]="true"
                [(ngValue)]="rfi.Question"
                [validate]="
                  (attemptToIssue && getStringLength(rfi.Question)===0) || getStringLength(rfi.Question) > maxLength1000 || baseFunctionService.isInputInvalid(rfi.Question)
                "
              ></aecom-textbox>
            </aecom-form-item>
            <aecom-form-item
              columnSpan="6"
              [label]="'Proposed Solution'"
              [property]="getStringLength(rfi.ProposedSolution) + '/' + maxLength500 + ' characters'"
              [required]="true"
              >
              <aecom-textbox
                rows="5"
                [theme]="'light'"
                [notEmpty]="true"
                [maxlength]="maxLength500"
                [isMultiLine]="true"
                [(ngValue)]="rfi.ProposedSolution"
                [validate]="
                  (attemptToIssue && getStringLength(rfi.ProposedSolution)===0) || getStringLength(rfi.ProposedSolution) > maxLength500 || baseFunctionService.isInputInvalid(rfi.ProposedSolution)
                "
              ></aecom-textbox>
            </aecom-form-item>
            <aecom-form-item
              columnSpan="6"
              [label]="'Anticipated Next Steps'"
              [property]="getStringLength(rfi.AnticipatedNextSteps) + '/' + maxLength500 + ' characters'"
              [required]="true"
              >
              <aecom-textbox
                rows="5"
                [theme]="'light'"
                [notEmpty]="true"
                [maxlength]="maxLength500"
                [isMultiLine]="true"
                [(ngValue)]="rfi.AnticipatedNextSteps"
                [validate]="
                  (attemptToIssue && getStringLength(rfi.AnticipatedNextSteps)===0) || getStringLength(rfi.AnticipatedNextSteps) > maxLength500 || baseFunctionService.isInputInvalid(rfi.AnticipatedNextSteps)
                "
              ></aecom-textbox>
            </aecom-form-item>
            <aecom-form-item columnSpan="3" [label]="'Attachments'">
              <aecom-upload
                [isNewStyle]="true"
                [multiFiles]="true"
                [canDelete]="true"
                [data]="baseFunctionService.getBBJFileListItemAttachment().fileList$ | async"
                [theme]="'light'"
                (ngValueChange)="baseFunctionService.importFile($event)"
                (ngDeleteChange)="baseFunctionService.deleteFile($event)"
              ></aecom-upload>
              @if (!(baseFunctionService.getBBJFileListItemAttachment().fileListNameValid$ | async)) {
                <div class="error-message">
                  File Name cannot include special characters other than '-', '_', '.', '@'
                </div>
              }
            </aecom-form-item>
          </aecom-form-group>
        </div>
        <div style="grid-column: span 3 / auto">
          <aecom-form-group columnSpan="3" title="{{ IsGARContract === true ? 'Additional info' : 'Metadata'}}">
            @if (!IsOldContract) {
              <aecom-form-item
                [label]="'Phase'"
                columnSpan="3"
                [required]="true"
                >
                @if (phaseList.length) {
                  <aecom-dropdown
                    [theme]="'light'"
                    placeholder="Select"
                    [data]="phaseList"
                    [selectedId]="rfi.PhaseId"
                    [validate]="attemptToIssue && !rfi.PhaseId"
                    (ngValueChange)="setPhaseList($event)"
                    (change)="setPhaseList($event)"
                  ></aecom-dropdown>
                }
              </aecom-form-item>
            }

            <aecom-form-item [label]="'Classification'" columnSpan="3" [required]="true">
              @if (classificationList.length) {
                <aecom-dropdown
                  [theme]="'light'"
                  placeholder="Select"
                  [data]="classificationList"
                  [selectedId]="rfi.ClassificationId"
                  [validate]="attemptToIssue && !rfi.ClassificationId"
                  (ngValueChange)="setClassificationList($event)"
                  (change)="setClassificationList($event)"
                ></aecom-dropdown>
              }
            </aecom-form-item>
            <aecom-form-item
              columnSpan="3"
              [label]="'Drawing and Detail Ref'"
              [property]="getStringLength(rfi.DrawingDetailRef) + '/' + maxLength250 + ' characters'"
              [required]="true"
              >
              <aecom-textbox
                [theme]="'light'"
                [notEmpty]="true"
                [maxlength]="maxLength250"
                [(ngValue)]="rfi.DrawingDetailRef"
                [validate]="
                  (attemptToIssue && getStringLength(rfi.DrawingDetailRef)===0) || getStringLength(rfi.DrawingDetailRef) > maxLength250 || baseFunctionService.isInputInvalid(rfi.DrawingDetailRef)
                "
              ></aecom-textbox>
            </aecom-form-item>
            @if (!IsOldContract) {
              <aecom-form-item
              [label]="
                'Contract Requirements (DBA/GPR/SPR)'
              " 
                columnSpan="3"
                [required]="IsContractRequirementRequied"
                >
                @if (contractRequirementList.length) {
                  <aecom-dropdown
                    [theme]="'light'"
                    placeholder="Select"
                    [data]="contractRequirementList"
                    [autocomplete]="true"
                    [selectedId]="rfi.ContractRequirementId"
                [validate]="
                  attemptToIssue && 
                  (!IsContractRequirementRequied ? false : (rfi.ContractRequirementId === undefined))
                " 
                    (ngValueChange)="setContractRequirementList($event)"
                    (searchedValue)="setContractRequirementList($event)"
                    (change)="setContractRequirementList($event)"
                  ></aecom-dropdown>
                }
              </aecom-form-item>
            }

            <aecom-form-item
              [label]="
                IsGARContract 
                  ? 'Division' 
                  : 'UniFormat Level 1 Category'
              " 
              columnSpan="3"
              [required]="IsGARContract || IsUniformatRequired"
              >
              <aecom-dropdown
                [theme]="'light'"
                placeholder="Select"
                [data]="divisionList"
                [autocomplete]="true"
                [selectedId]="division"
                [validate]="
                  attemptToIssue && 
                  (!IsUniformatRequired ? false: (division === undefined))
                "
                (ngValueChange)="setDivisionList($event)"
                (searchedValue)="setDivisionList($event)"
                (change)="setDivisionList($event)"
              ></aecom-dropdown>
            </aecom-form-item>

            <aecom-form-item
              [label]="
                IsGARContract 
                  ? 'Specification' 
                  : 'UniFormat Level 2 Category'
              " 
              columnSpan="3"
              [required]="IsGARContract || IsUniformatRequired"
              >
              <aecom-dropdown
                [theme]="'light'"
                placeholder="Select"
                [data]="specificationCleanList"
                [autocomplete]="true"
                [selectedId]="rfi.SpecificationId"
                [validate]="
                  attemptToIssue && 
                    (!IsUniformatRequired ? false : (rfi.SpecificationId === undefined))
                "
                (ngValueChange)="setSpecificationList($event)"
                (searchedValue)="setSpecificationList($event)"
                (change)="setSpecificationList($event)"
              ></aecom-dropdown>
            </aecom-form-item>

            @if (!IsGARContract) {
              <aecom-form-item
                [label]="'MasterFormat Specification Section (6-digit)'"
                columnSpan="3"
                >
                <aecom-dropdown
                  [theme]="'light'"
                  placeholder="Select"
                  [data]="masterSpecCleanList"
                  [autocomplete]="true"
                  [selectedId]="rfi.MasterSpecId"
                  (ngValueChange)="setMasterSpecList($event)"
                  (searchedValue)="setMasterSpecList($event)"
                  (change)="setMasterSpecList($event)"
                ></aecom-dropdown>
              </aecom-form-item>
            }

            <aecom-form-item [label]="'Anticipated Schedule Impact?'" columnSpan="3" [required]="true">
              <div class="button-wrapper d-flex">
                <aecom-button
                  innerClass="btn solid btn-tab {{
                    rfi.AnticipatedScheduleImpact === true ? 'blue' : 'bg-grey-e'
                  }}"
                  (click)="setAnticipatedScheduleImpact(true)"
                  >
                  Yes
                </aecom-button>

                <aecom-button
                  innerClass="btn solid btn-tab {{
                    rfi.AnticipatedScheduleImpact === false ? 'blue' : 'bg-grey-e'
                  }}"
                  (click)="setAnticipatedScheduleImpact(false)"              >
                  No
                </aecom-button>
              </div>
            </aecom-form-item>
            @if (rfi.AnticipatedScheduleImpact) {
              <aecom-form-item
                [label]="'Schedule Impact Details'"
                [property]="getStringLength(rfi.ScheduleImpactDetails) + '/' + maxLength150 + ' characters'"
                columnSpan="3"
                >
                <aecom-textbox
                  rows="5"
                  [theme]="'light'"
                  [notEmpty]="true"
                  [maxlength]="maxLength150"
                  [isMultiLine]="true"
                  [(ngValue)]="rfi.ScheduleImpactDetails"
                  [validate]="getStringLength(rfi.ScheduleImpactDetails) > maxLength150 || baseFunctionService.isInputInvalid(rfi.ScheduleImpactDetails)"
                ></aecom-textbox>
              </aecom-form-item>
            }
            <aecom-form-item [label]="'Anticipated Cost Impact?'" columnSpan="3" [required]="true">
              <div class="button-wrapper d-flex">
                <aecom-button
                  innerClass="btn solid btn-tab {{
                    rfi.AnticipatedCostImpact === true ? 'blue' : 'bg-grey-e'
                  }}"
                  (click)="setAnticipatedCostImpact(true)"
                  >
                  Yes
                </aecom-button>

                <aecom-button
                  innerClass="btn solid btn-tab {{
                    rfi.AnticipatedCostImpact === false ? 'blue' : 'bg-grey-e'
                  }}"
                  (click)="setAnticipatedCostImpact(false)"              >
                  No
                </aecom-button>
              </div>
            </aecom-form-item>
            @if (rfi.AnticipatedCostImpact) {
              <aecom-form-item
                [label]="'Cost Impact Details'"
                [property]="getStringLength(rfi.CostImpactDetails) + '/' + maxLength150 + ' characters'"
                columnSpan="3"
                >
                <aecom-textbox
                  rows="5"
                  [theme]="'light'"
                  [notEmpty]="true"
                  [maxlength]="maxLength150"
                  [isMultiLine]="true"
                  [(ngValue)]="rfi.CostImpactDetails"
                  [validate]="getStringLength(rfi.CostImpactDetails) > maxLength150 || baseFunctionService.isInputInvalid(rfi.CostImpactDetails)"
                ></aecom-textbox>
              </aecom-form-item>
            }
            <!-- <aecom-form-item [label]="'Type (Optional)'" columnSpan="3">
            <aecom-checkbox [theme]="'light'" [(ngValue)]="rfi.isConfidential">
              Is Confidential
            </aecom-checkbox>
          </aecom-form-item> -->
        </aecom-form-group>
      </div>
      <div style="grid-column: span 3 / auto">
        <aecom-form-group columnSpan="3" title="{{ IsGARContract === true ? 'References' : 'Additional Details'}}">
          <aecom-form-item [label]="'Priority'" columnSpan="3">
            <div class="button-wrapper d-flex">
              <aecom-button
                  innerClass="btn solid btn-tab {{
                    rfi.Priority === 1 ? 'blue' : 'bg-grey-e'
                  }}"
                (click)="setPriority(1)"
                >
                Low
              </aecom-button>

              <aecom-button
                  innerClass="btn solid btn-tab {{
                    rfi.Priority === 2 ? 'blue' : 'bg-grey-e'
                  }}"
                (click)="setPriority(2)"
                >
                Medium
              </aecom-button>

              <aecom-button
                  innerClass="btn solid btn-tab {{
                    rfi.Priority === 3 ? 'blue' : 'bg-grey-e'
                  }}"
                (click)="setPriority(3)"
                >
                High
              </aecom-button>
            </div>

          </aecom-form-item>
          @if (rfi.Priority === 3) {
            <aecom-form-item
              [property]="getStringLength(rfi.PriorityReason) + '/' + maxLength150 + ' characters'"
              columnSpan="3"
              >
              <aecom-textbox
                rows="5"
                [theme]="'light'"
                [notEmpty]="true"
                [maxlength]="maxLength150"
                [isMultiLine]="true"
                [(ngValue)]="rfi.PriorityReason"
                [validate]="(attemptToIssue && getStringLength(rfi.PriorityReason)===0) || getStringLength(rfi.PriorityReason) > maxLength150 || baseFunctionService.isInputInvalid(rfi.PriorityReason)"
                placeholder="Please enter the reason."
              ></aecom-textbox>
            </aecom-form-item>
          }

          <aecom-form-item
            [label]="'Processing Notes'"
            [property]="getStringLength(rfi.ProcessingNotes) + '/' + maxLength150 + ' characters'"
            columnSpan="3"
            >
            <aecom-textbox
              rows="5"
              [theme]="'light'"
              [notEmpty]="false"
              [maxlength]="maxLength150"
              [isMultiLine]="true"
              [(ngValue)]="rfi.ProcessingNotes"
              [validate]="getStringLength(rfi.ProcessingNotes) > maxLength150 || baseFunctionService.isInputInvalid(rfi.ProcessingNotes)"
              >
            </aecom-textbox>
          </aecom-form-item>

          @if (IsRevise) {
            <div class="tab-container">
              <div class="tab-header">
                <span class="tab-title"
                  >QA/QC Failed Note by :
                  @if (noteBy) {
                    <span class="color-red">{{ noteBy }}</span>
                  }
                </span>
              </div>
              <div class="bottom-padding">
                <div class="content-value" [innerHtml]="note"></div>
              </div>
            </div>
          }

          <!-- <div style="display: block; color: black;">
          <div>
            IsDesignClassification: {{IsDesignClassification}}
          </div>
          <div>
            IsOldContract: {{IsOldContract}}
          </div>
          <div>
            IsGARContract: {{IsGARContract}}
          </div>
          <div>
            canIssue: {{canIssue()}}
          </div>
          <div>
            attempToIssue: {{attemptToIssue}}
          </div>
          <div>
            Internal Reference Number: {{rfi.ContractorReference}}
          </div>
          <div>
            Title: {{rfi.Title}}
          </div>
          <div>
            Question: {{rfi.Question}}
          </div>
          <div>
            Phase: {{rfi.PhaseId}}
          </div>
          <div>
            Classification: {{rfi.ClassificationId}}
          </div>
          <div>
            Contract Requirements: {{rfi.ContractRequirementId}}
          </div>
          <div>
            Contract Requirements inValid: {{
            attemptToIssue &&
            ((!IsDesignClassification || rfi.ClassificationId===undefined) ? false : (rfi.ContractRequirementId === undefined))                }}
          </div>
          <div>
            Division: {{division}}
          </div>
          <div>
            Division inValid: {{
            attemptToIssue &&
            ((IsDesignClassification || rfi.ClassificationId===undefined) ? false: (division === undefined))
            }}
          </div>
          <div>
            Specification: {{rfi.SpecificationId}}
          </div>
          <div>
            Specification inValid: {{
            attemptToIssue &&
            ((IsDesignClassification || rfi.ClassificationId===undefined) ? false : (rfi.SpecificationId === undefined))
            }}
          </div>
          <div>
            MasterSpec: {{rfi.MasterSpecId}}
          </div>
          <div>
            AnticipatedScheduleImpact: {{rfi.AnticipatedScheduleImpact}}
          </div>
          <div>
            AnticipatedCostImpact: {{rfi.AnticipatedCostImpact}}
          </div>
          <div>
            Priority: {{rfi.Priority}}
          </div>
          <div>
            Priority Reason: {{rfi.PriorityReason}}
          </div>
          <div>
            Processing Notes: {{rfi.ProcessingNotes }}
          </div>
        </div> -->
      </aecom-form-group>
    </div>
  </aecom-form>
</div>
</div>
</div>
